<template>
  <div class="page-content">
    <div class="page-header">
      <div>
        <BreadcrumbComponent :items="items" />
        <h1 class="page-title">Configuration KL Pay</h1>
        <p class="page-subtitle">Réception des paiements wallet (MonCash &amp; NatCash) via la gateway KL Pay</p>
      </div>
    </div>

    <PreloaderComponent :enable="enable" />

    <div v-if="enable">
      <v-row>
        <v-col cols="12" md="8" lg="6">
          <v-card flat class="settings-card">
            <v-card-text class="pa-6">
              <div class="d-flex align-center mb-4">
                <v-chip small :color="secretConfigured ? 'green lighten-4' : 'orange lighten-4'"
                        :text-color="secretConfigured ? 'green darken-3' : 'orange darken-3'">
                  {{ secretConfigured ? 'Compte configuré' : 'Compte non configuré' }}
                </v-chip>
              </div>

              <p v-if="!secretConfigured" class="text-caption grey--text mb-4">
                Renseignez les identifiants API fournis par KL Pay. Le secret n'est affiché
                qu'une seule fois à sa création côté KL Pay : conservez-le précieusement.
                Une fois enregistré ici, il ne sera plus jamais réaffiché.
              </p>
              <v-alert v-else dense text type="info" class="text-caption mb-4">
                Compte configuré et verrouillé. Pour modifier les identifiants KL Pay,
                contactez un administrateur KES LAKAY.
              </v-alert>

              <v-text-field
                v-model="apiKey"
                label="Clé API (api_key)"
                placeholder="klp_..."
                outlined
                dense
                autocomplete="off"
                :disabled="secretConfigured"
              ></v-text-field>

              <v-text-field
                v-if="!secretConfigured"
                v-model="apiSecret"
                label="Secret API (api_secret)"
                outlined
                dense
                :append-icon="showSecret ? 'mdi-eye-off' : 'mdi-eye'"
                :type="showSecret ? 'text' : 'password'"
                @click:append="showSecret = !showSecret"
                autocomplete="new-password"
              ></v-text-field>
              <v-text-field
                v-else
                value="••••••••••••"
                label="Secret API (api_secret)"
                outlined
                dense
                disabled
              ></v-text-field>

              <v-btn v-if="!secretConfigured" color="primary" depressed :loading="saving" :disabled="!canSave" @click="save">
                Enregistrer
              </v-btn>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="4" lg="6">
          <v-card flat class="settings-card">
            <v-card-text class="pa-6">
              <h3 class="text-subtitle-2 mb-3">Comment ça marche ?</h3>
              <p class="text-caption grey--text mb-2">
                • À la caisse, le vendeur choisit la méthode <strong>KL Pay</strong> et saisit le
                numéro du client : MonCash ou NatCash est détecté automatiquement selon le préfixe.
              </p>
              <p class="text-caption grey--text mb-2">
                • Le client confirme sur son téléphone (USSD). La vente se valide seule dès confirmation.
              </p>
              <p class="text-caption grey--text mb-0">
                • KL Pay reverse directement les fonds à votre compte : plus de demande de retrait
                à faire depuis ce dashboard.
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <v-snackbar v-model="snackbar" :timeout="3500" :color="snackbarColor">
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>
import PreloaderComponent from '../../components/PreloaderComponent.vue'
import BreadcrumbComponent from '../../components/BreadcrumbComponent.vue'

export default {
  name: 'KlPaySettingsView',
  components: { BreadcrumbComponent, PreloaderComponent },
  data: () => ({
    enable: false,
    saving: false,
    apiKey: '',
    apiSecret: '',
    showSecret: false,
    secretConfigured: false,
    snackbar: false,
    snackbarText: '',
    snackbarColor: 'success',
    items: [
      { text: 'ACCUEIL', disabled: false, href: '/' },
      { text: 'KL PAY', disabled: false, href: '/klpay/settings' },
      { text: 'CONFIGURATION', disabled: true, href: '/klpay/settings' },
    ],
  }),
  computed: {
    canSave() {
      // Configuration initiale uniquement (une fois configuré, le formulaire est
      // verrouillé — seuls les administrateurs peuvent modifier) : clé + secret requis.
      return !!(this.apiKey && this.apiSecret) && !this.secretConfigured
    },
  },
  methods: {
    businessId() {
      return JSON.parse(localStorage.business).id
    },
    load() {
      this.enable = false
      const self = this
      this.$axios.get('/businesses/' + this.businessId())
        .then(function (response) {
          // L'endpoint peut renvoyer le modèle brut, un tableau [modèle],
          // ou une enveloppe { data: ... } : on normalise.
          var raw = response.data
          if (Array.isArray(raw)) raw = raw[0]
          if (raw && raw.data && !raw.klpay_api_key && !raw.id) raw = Array.isArray(raw.data) ? raw.data[0] : raw.data
          var biz = raw || {}
          self.apiKey = biz.klpay_api_key || ''
          self.secretConfigured = !!biz.klpay_secret_configured
          self.enable = true
        }).catch(function () {
          self.enable = true
        })
    },
    save() {
      const payload = { klpay_api_key: this.apiKey.trim() }
      if (this.apiSecret) {
        payload.klpay_api_secret = this.apiSecret.trim()
      }
      this.saving = true
      const self = this
      this.$axios.put('/businesses/' + this.businessId() + '?data=' + encodeURIComponent(JSON.stringify(payload)))
        .then(function () {
          self.saving = false
          self.apiSecret = ''
          self.snackbarColor = 'success'
          self.snackbarText = 'Identifiants KL Pay enregistrés'
          self.snackbar = true
          self.load()
        }).catch(function () {
          self.saving = false
          self.snackbarColor = 'error'
          self.snackbarText = "Échec de l'enregistrement, réessayez"
          self.snackbar = true
        })
    },
  },
  mounted() {
    this.load()
  },
}
</script>

<style scoped>
.settings-card { border: 1px solid #e8ecf1 !important; border-radius: 8px !important; box-shadow: 0 1px 3px rgba(0,0,0,0.04) !important; }
</style>
